/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendLoginDto } from '../../models/backend-login-dto';
import { BackendLoginRequestDto } from '../../models/backend-login-request-dto';

export interface AccountLoginCreate$XWwwFormUrlencoded$Params {
  body: BackendLoginRequestDto;
}

export function accountLoginCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: AccountLoginCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendLoginDto>> {
  const rb = new RequestBuilder(rootUrl, accountLoginCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendLoginDto>;
    }),
  );
}

accountLoginCreate$XWwwFormUrlencoded.PATH = '/api/account/login/';
